import { z } from 'zod'

export const travelAmountStatisticsProgramFeedbackSchema = z.object({
  /** 檻次順序 */
  thresholdSort: z.number(),
  /** 檻次金額 */
  amount: z.number(),
  /** 回饋項目數量 */
  courtesyCount: z.number()
})

export interface TravelAmountStatisticsProgramFeedback
  extends z.infer<typeof travelAmountStatisticsProgramFeedbackSchema> {}
